import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: '¿Necesito adquirir productos costosos?',
  a: 'No. La guía está diseñada para funcionar con alimentos y hábitos accesibles del día a día. No requiere suplementos, equipos especiales ni gastos adicionales.'
}, {
  q: '¿Es un plan restrictivo?',
  a: 'Para nada. El Código Hormonal 40+ se basa en nutrición consciente y placentera. No eliminamos grupos de alimentos ni contamos calorías. Se trata de aprender a escuchar tu cuerpo y disfrutar el proceso.'
}, {
  q: '¿Cuánto tiempo al día requiere?',
  a: 'Entre 15 y 30 minutos diarios es suficiente. Las rutinas están diseñadas para integrarse fácilmente en tu vida sin interrumpir tus responsabilidades.'
}, {
  q: '¿Es adecuado para cualquier etapa después de los 40?',
  a: 'Sí. La guía fue pensada para mujeres en sus 40s, 50s y 60s. Cada etapa tiene sus propios ritmos y el programa los respeta y celebra.'
}, {
  q: '¿Cómo recibo mi guía digital?',
  a: 'Inmediatamente después de completar tu pago recibirás un correo con el enlace de descarga. Puedes acceder desde cualquier dispositivo — teléfono, tablet o computadora.'
}, {
  q: '¿Qué pasa si siento que no es para mí?',
  a: 'Queremos que estés 100% satisfecha con tu experiencia. Si tienes alguna pregunta o necesitas orientación sobre cómo aprovechar la guía al máximo, escríbenos a support@upreferr.com y te ayudamos personalmente. Dado que es un producto digital con acceso inmediato, no procesamos devoluciones automáticas, pero siempre encontramos la manera de que tu experiencia valga la pena.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 lg:py-32 bg-[var(--color-cream)]" data-id="element-14">
      <div className="container mx-auto px-6 lg:px-12" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto" data-id="element-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[var(--color-charcoal)] text-center mb-16" data-id="element-17">
            Preguntas frecuentes
          </h2>

          <div className="space-y-4" data-id="element-18">
            {faqs.map((faq, i) => {
            const isOpen = openIndex === i;
            return <div key={i} className="bg-white rounded-2xl border border-[var(--color-pale-pink)] overflow-hidden" data-id="element-19">
                  <button onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="w-full flex items-center justify-between gap-4 px-6 lg:px-8 py-6 text-left" data-id="element-20">
                    <span className="text-lg lg:text-xl font-semibold text-[var(--color-charcoal)]" data-id="element-21">
                      {faq.q}
                    </span>
                    <span className="flex-shrink-0 bg-[var(--color-pale-pink)] rounded-full p-1.5" data-id="element-22">
                      {isOpen ? <MinusIcon className="w-5 h-5 text-[var(--color-dark-sage)]" data-id="element-23" /> : <PlusIcon className="w-5 h-5 text-[var(--color-dark-sage)]" data-id="element-24" />}
                    </span>
                  </button>
                  <AnimatePresence initial={false} data-id="element-25">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} className="overflow-hidden" data-id="element-26">
                        <p className="px-6 lg:px-8 pb-6 text-base lg:text-lg text-[var(--color-charcoal)] opacity-70 font-light leading-relaxed" data-id="element-27">
                          {faq.a}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </motion.div>
      </div>
    </section>;
}